import React from "react";

const Procedure = () => {
  // Hardcoded list of procedure data
  const procedures = [
    { name: "1-7 ALIGNERS (DUAL ARCH)", department: "ALIGNERS", schedule: "5", sort: "1" },
    { name: "1-7 ALIGNERS (SINGLE ARCH)", department: "ALIGNERS", schedule: "", sort: "1" },
    { name: "3D PRINTED MODELS", department: "Stackable Stent", schedule: "", sort: "1" },
    { name: "3D PRINTED STUDY MODELS", department: "STUDY MODELS", schedule: "5", sort: "1" },
    { name: "ACRYLIC DENTURE WITH IMPLANT ATTACHMENT (2 LOCATORS)", department: "IMPLANTS", schedule: "", sort: "1" },
    { name: "ANKYLOS ND Sleeves - 4.48mm", department: "", schedule: "", sort: "1" },
  ];

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      {/* Title */}
      <h2 style={{ color: "#004aad", paddingBottom: "3px" }}>Procedures</h2>

      {/* Table for displaying procedures */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
        <thead>
          <tr style={{ backgroundColor: "#f4f4f4", textAlign: "left" }}>
            {/* Table headers */}
            <th style={headerStyle}>Name</th>
            <th style={headerStyle}>Department</th>
            <th style={headerStyle}>Schedule</th>
            <th style={headerStyle}>Sort</th>
          </tr>
        </thead>
        <tbody>
          {/* Rendering each procedure as a table row */}
          {procedures.map((item, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={cellStyle}>{item.name}</td>
              <td style={cellStyle}>{item.department}</td>
              <td style={cellStyle}>{item.schedule}</td>
              <td style={cellStyle}>{item.sort}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styling for table headers
const headerStyle = {
  padding: "10px",
  borderTop: "3px solid #004aad",
  fontWeight: "bold",
};

// Styling for table cells
const cellStyle = {
  padding: "10px",
};

export default Procedure;
